import { useEffect } from "react";

import { useFetchProductTagsQuery } from "@src/generated";

export function useProductTags() {
  const { data, loading, fetchMore } = useFetchProductTagsQuery();
  const hasNextPage = data?.productTags?.pageInfo.hasNextPage;
  const after = data?.productTags?.pageInfo.endCursor;
  useEffect(() => {
    if (!loading && hasNextPage && after) {
      void fetchMore({
        variables: { after },
      });
    }
  }, [loading, hasNextPage, after]);
  return data;
}
